import { MedicinePrescriptionQuery } from '@dreryk/egabinet-prescription-frontend-api';
import { EwusStatus } from '@dreryk/egabinet-ewus-frontend-api';

import { CqrsQueryPerformResult, performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { Choice, Slot } from '@dreryk/watermelon';

import { assertUnreachable } from '~libs.typescript';

import { MedicineId, MedicinePrescription, StandardMedicinePrescription, VisitPatientId } from '../types';
import { isStandardMedicinePrescription } from '../guards/isStandardMedicinePrescription';
import { isMagistralDrugMedicinePrescription } from '../guards/isMagistralDrugMedicinePrescription';

type FetchStandardMedicinePrescriptionParameters = {
   patientId: VisitPatientId;
   medicineId: MedicineId;
   ewusStatus: EwusStatus;
};

export const fetchStandardMedicinePrescription = async (
   parameters: FetchStandardMedicinePrescriptionParameters
): CqrsQueryPerformResult<StandardMedicinePrescription> => {
   return performCqrsQueryGet<StandardMedicinePrescription>(() => {
      const query = new MedicinePrescriptionQuery();
      query.patientId = parameters.patientId;
      query.medicineId = Slot.of(parameters.medicineId);
      query.ewusStatus = Choice.withUseDefaultIfNull(parameters.ewusStatus);
      return query;
   });
};

export const getMedicineName = (medicinePrescription: MedicinePrescription): string => {
   if (isStandardMedicinePrescription(medicinePrescription)) {
      return medicinePrescription.patientMedicine.medicine.fullName;
   }

   if (isMagistralDrugMedicinePrescription(medicinePrescription)) {
      return medicinePrescription.magistralDrug.name;
   }

   return assertUnreachable();
};
